var _line, _circle, _line2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuAllocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 10.5,
    x2: 16.5,
    y2: 10.5,
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 2.5,
    fill: "white",
    stroke: "#217EE2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 3.5,
    x2: 16.5,
    y2: 3.5,
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 3.5,
    r: 2.5,
    fill: "white",
    stroke: "#217EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAllocation);
export default __webpack_public_path__ + "static/media/menu-allocation.93f4b76c4ba4c14ed360abe2463fdc0c.svg";
export { ForwardRef as ReactComponent };